<template>
  <div class="">
    <div class="mywrong-top">
      <div class="disFlex wrongSear" style="align-items: center;">
        <span class="wrongLabel">课程大类</span>
        <span :class="formInline.parentid==''?'active':''" @click="changeParams('parentid','')">全部</span>
        <span v-for="(item,i) in options" :class="formInline.parentid.indexOf(item.uniqueCode)>=0?'active':''"
          @click="changeParams('parentid',item.uniqueCode,i)">{{item.text}}</span>

      </div>
      <div class="disFlex wrongSear">
        <div class="wrongLabel">
          <span class="wrongLabel">课程小类</span>
        </div>
        <div class="disFlex" style="flex-wrap: wrap;align-items: center;">
          <span :class="formInline.parentid==''||formInline.parentid.split('_').length==3?'active':''">全部</span>
          <span v-for="k in childList" @click="changeParams('parentid',k.uniqueCode)"
            :class="formInline.parentid==k.uniqueCode?'active':''">{{k.text}}</span>
        </div>
      </div>
    </div>

    <div class="mywrong-cont" v-loading="loading">
      <div v-if="tableData.rows.length>0">
        <div v-for="(item,k) in tableData.rows" :class="'mywrongEvery'" @click="toReerror(item.id)">
          <div class="mywrongEveryTm">
            <span v-if="item.itype=='1'">[单选题]</span>
            <span v-if="item.itype=='2'">[多选题]</span>
            <span v-if="item.itype=='3'">[判断题]</span>
            <span v-if="item.itype=='4'">[填空题]</span>
            <span v-if="item.itype=='5'">[简答题]</span>
            {{item.cname}}
          </div>
          <div class="mywrongEveryCtcs" style="color: #9A9A9A;">错误次数：<span
              style="color: #D50000;">{{item.errornum}}</span></div>
        </div>
      </div>
      <div v-else style="height: 200px;background-color: #fff;text-align: center;">
        <img style="margin: 70px 0 20px;" src="@/assets/images/nodata.png" />
        <div style="font-size: 18px;color: #999999;">暂无数据</div>
      </div>

      <el-pagination background style="margin-top: 10px;text-align: right;" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page="formInline.page" :page-sizes="[10, 20, 50, 100]"
        :page-size="formInline.rows" layout="total, sizes, prev, pager, next, jumper" :total="tableData.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import {
    getItype
  } from '@/assets/js/common.js';
  export default {
    name: 'Muwrong',
    props: ['currentUser', 'wjSrc'],
    data() {
      return {
        options: [],
        childList: [],
        formInline: {
          parentid: '',
          rows: 10,
          page: 1,
          creator: ''
        },
        tableData: {
          rows: [],
          total: 0
        },
        loading: true
      }
    },
    methods: {
      changeParams: function(key, val,i) {
        if(i){
          this.childList=this.options[i].children;
        }
        this.$set(this.formInline, key, val);
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size)
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
      },
      getList: function(id) {
        this.loading = true;
        this.$axios.get('/kt/ktProductAppy/geterror.htm?' + this.$qs.stringify(this.formInline)).then(res => {
          var data = res.data;
          this.tableData = data;
          this.loading = false;
        })
      },
      toReerror: function(id) {
        this.$router.push('/reerror?id=' + id);
      }
    },
    components: {},
    created: function() {
      getItype(this.$axios, ((res) => {
        this.options = res;
        this.childList = res[0].children;
      }));
      this.$set(this.formInline, 'creator', this.currentUser.id);
    },
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getList()
        },
        deep: true //true 深度监听
      }
    }
  }
</script>


<style>
  .mywrong-top {
    border: 1px solid #f2f2f2;
    padding: 27px 20px;
  }

  .wrongSear {
    margin-bottom: 15px;
  }

  .mywrong-cont {
    padding: 0 20px 50px 20px;
  }

  .wrongSear span {
    margin-right: 15px;
    padding: 3px 15px;
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: left;
    color: #333333;
    line-height: 20px;
    cursor: pointer;
  }

  .wrongSear span.active {
    background: #e4f3fc;
    color: #0071BA;
    border-radius: 13px;
  }

  .wrongSear span.wrongLabel {
    height: 20px;
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 500;
    text-align: left;
    color: #333333;
    line-height: 20px;
    /* margin-right: 24px; */
    padding: 3px 0;
    width: 90px;
    display: inline-block;
  }

  .mywrongEvery {
    opacity: 1;
    border-bottom: 1px solid #F2F2F2;
    margin: 20px auto;
    text-align: left;
    padding-bottom: 20px;
  }

  .mywrongEveryTm {
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    color: #333333;
    line-height: 20px;
    letter-spacing: 1px;
    margin-bottom: 10px;
  }

  .mywrongEveryTm span {
    color: #0071BA;
    padding-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/xueyuan/WronCard.vue